import React, { useContext, useEffect } from "react";
import SafetyStock from "../Components/SafetyStock"
import UnmetDemand from "../Components/UnmetDemand"

import TableContext from "../Context/TablePosition";
import { useLocation } from "react-router-dom";


export default function StatusInfo() {
  const { setCurrentUrl } = useContext(TableContext)
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem("urlpaintshop", location.pathname)
    setCurrentUrl(localStorage.getItem("urlpaintshop"));
  }, [location.pathname, setCurrentUrl])
  return (
    <div className="flex w-full flex-col h-full mt-4 overflow-hidden">
      <div className="flex flex-col desktop:flex-row gap-4 overflow-y-auto overflow-x-hidden">
        <div className="desktop:w-1/2 w-full min-w-0">
          <SafetyStock />
        </div>
        <div className="desktop:w-1/2 w-full min-w-0">
          <UnmetDemand />
        </div>
      </div>
    </div>
  );
}

